/* ---------------------------------------------------------------------------
   Collectiefilters: bereikvakjes en "Meer filters"

   Twee taken:

   1. Een band ("10 tot 20 W") is één zichtbaar vakje zonder name, met daaronder
      de echte filterwaarden als verborgen vakjes. Vink je de band aan, dan gaan
      die allemaal mee. Het thema luistert op change van [name^="filter."] en
      leest dan de hele form uit met FormData — verborgen vakjes tellen daarin
      gewoon mee zolang ze aangevinkt zijn. We hoeven dus alleen te synchroniseren
      en daarna één change te laten opborrelen.

   2. Alleen de eerste filters staan open; de rest zit achter "Meer filters".
      Het thema vervangt de innerHTML van beide filterformulieren bij elke
      verversing, dus de open-stand wordt daarna opnieuw gezet.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var extraZichtbaar = false;

  function synchroniseerBand(leider) {
    var groep = leider.getAttribute('data-band');
    var form = leider.closest('form');
    if (!form) return;

    var leden = form.querySelectorAll('input[data-band-member="' + groep + '"]');
    if (!leden.length) return;

    for (var i = 0; i < leden.length; i++) {
      leden[i].checked = leider.checked;
    }

    // Laat het thema zelf de URL opbouwen en de sectie herladen.
    leden[0].dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener(
    'change',
    function (event) {
      var doel = event.target;
      if (!doel || !doel.getAttribute || !doel.getAttribute('data-band')) return;
      synchroniseerBand(doel);
    },
    true
  );

  function zetExtraStand() {
    var lijsten = document.querySelectorAll('.collection__filter-group-list');
    for (var i = 0; i < lijsten.length; i++) {
      lijsten[i].classList.toggle('is-showing-extra', extraZichtbaar);
    }

    var knoppen = document.querySelectorAll('[data-filter-more]');
    for (var j = 0; j < knoppen.length; j++) {
      var knop = knoppen[j];
      knop.setAttribute('aria-expanded', extraZichtbaar ? 'true' : 'false');
      var tekst = knop.querySelector('[data-filter-more-label]');
      if (tekst) {
        tekst.textContent = extraZichtbaar
          ? knop.getAttribute('data-label-less')
          : knop.getAttribute('data-label-more');
      }
    }
  }

  document.addEventListener('click', function (event) {
    var knop = event.target.closest ? event.target.closest('[data-filter-more]') : null;
    if (!knop) return;
    event.preventDefault();
    extraZichtbaar = !extraZichtbaar;
    zetExtraStand();
  });

  // Na elke filterverversing bouwt het thema de formulieren opnieuw op.
  document.addEventListener('theme:loading:end', zetExtraStand);
  document.addEventListener('DOMContentLoaded', zetExtraStand);
})();
